<div class="tab-selector">
  @for (tab of tabValues; track tab) {
    <div
      class="tab-selector-tab"
      [ngClass]="{
        selected: selectedTabName === tab.name,
        disabled: selectDisabled,
      }"
      (click)="selectDisabled ? null : onTabClick(tab.name)"
    >
      @if (selectedTabName === tab.name) {
        <img class="tab-image" src="{{ tab.selectedIconSrc }}" />
      }
      @if (selectedTabName !== tab.name) {
        <img class="tab-image" src="{{ tab.iconSrc }}" />
      }
      <span class="tab-name">{{ tab.name }}</span>
    </div>
  }
</div>
